import FullCC from "./Full";
import TokenizedCC from "./Tokenized";

interface CCProps {
  className?: string;
  cvv?: string;
  fieldPrefix?: string;
  hideCvv?: boolean;
  readonly?: boolean;
  tokenizedCard?: be.TokenizedCreditCard;
  notRequired?: boolean;
}

function CreditCard({
  className = "",
  cvv,
  fieldPrefix = "",
  hideCvv,
  notRequired,
  readonly,
  tokenizedCard,
}: CCProps): JSX.Element {
  const tempToken = tokenizedCard?.token && tokenizedCard?.tokenType == "temp";

  let cc;
  if (!readonly && (!tokenizedCard?.token || tempToken)) {
    cc = (
      <FullCC
        className={className}
        cvv={cvv}
        fieldPrefix={fieldPrefix}
        hideCvv={hideCvv}
        tokenizedCard={tokenizedCard}
        notRequired={notRequired}
      />
    );
  } else {
    cc = <TokenizedCC className={className} tokenizedCard={tokenizedCard} />;
  }

  return cc;
}

export default CreditCard;
